var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"weapon-cases-container"},[_c('Banner',{attrs:{"bannerList":_vm.bannerList}}),_c('Cases',{attrs:{"casesList":_vm.casesList}}),_c('Footer',{ref:"footerRef"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }